export enum BookingType {
    Collection = 'Collection',
    Delivery = 'Delivery',
    Resource = 'Resource',
    Internal = 'Internal',
    DeliveryAndCollection = 'Delivery and Collection',
    NoBookings = 'No Bookings'
}
